import React from 'react';
import clsx from 'clsx';

import { Icon, ButtonIcon } from '@/components';

import KIND_TYPE from '@/fixtures/kindType';

const FLAG_SRC = 'https://purecatamphetamine.github.io/country-flag-icons/3x2/';

import './styles.scss';

const ContactField = ({ field, onClickAction, ...props }) => {
  const handleCopyAddress = value => {
    navigator.clipboard.writeText(value);
  };

  // const getActionLink = (kind, value) => {
  //   const isLink = (val) => /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/.test(val);

  //   console.log(`isLink`, isLink(value))

  //   const formatLink = (val) => {
  //     if (!isLink(val)) return val;
  //     return /^https?:\/\//i.test(val) ? val : `https://${val}`;
  //   };

  //   const kindType = {
  //     language: formatLink(value),
  //     call: `tel:${value}`,
  //     sms: `sms:${value}`
  //   };

  //   return kindType[kind] || `mailto:${value}`;
  // };
  const getActionLink = (kind, value) => {
    const isLink = (val) => /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/.test(val);

    const formatLink = (val) => {
      if (!isLink(val)) return null; // Return null if not a link
      return /^https?:\/\//i.test(val) ? val : `https://${val}`;
    };

    const kindType = {
      language: formatLink(value),
      call: `tel:${value}`,
      sms: `sms:${value}`
    };

    return kindType[kind] ?? isLink(value) ? formatLink(value) : `mailto:${value}`;
  };

  if (field.label === 'Profile Photo') {
    return (<></>);
  } else {
    return (
      <div className='contact-field' {...props}>
        <div className='wrapper'>
          <div className='label'>
            <span>{field.label}</span>
          </div>
          <div className='inner'>
            <div className={clsx('value', (field.label == 'Company Logo' || field.label == 'Business Card') ? '-logo' : field.country ? '-flag' : '')}>
              {field.country && (
                <img
                  src={`${FLAG_SRC}${field.country}.svg`}
                  alt={`${field.country}-flag`}
                  className='flag'
                />
              )}

              {(field.label != 'Company Logo' && field.label != 'Business Card') ? (<span>{field.value}</span>) : (<img src={field.value} alt='' className='logo' />)}
            </div>
            {(field.label != 'Company Logo' && field.label != 'Business Card') && (<div className='action'>
              {field.kind?.toLowerCase() === 'place' ? (
                <ButtonIcon
                  icon={KIND_TYPE[field.kind?.toLowerCase()]}
                  onClick={() => handleCopyAddress(field.value)}
                />
              ) :
                (() => {
                  const href = getActionLink(field.kind?.toLowerCase(), field.value);
                  return href && field.label == 'Website' ? (
                    <a
                      target='_blank'
                      onClick={() => onClickAction('website')}
                      href={href}
                    >
                      <Icon name={KIND_TYPE['website']} />
                    </a>
                  ) : (
                    <span
                      onClick={() => onClickAction(field.kind?.toLowerCase())}
                      style={{ cursor: 'default' }}
                    >
                      <Icon name={KIND_TYPE[field.kind?.toLowerCase()]} />
                    </span>
                  );
                }
                )()
              }
            </div>)}
          </div>
        </div>
      </div>
    );
  }
};

export default ContactField;
